import { createSlice } from '@reduxjs/toolkit';

interface MultiLanguageState {
    isModalOpen: boolean;
    isModalOpenInSidebar: boolean;
}

const initialState: MultiLanguageState = {
    isModalOpen: false,
    isModalOpenInSidebar: false,
};

const multiLanguageSlice = createSlice({
    name: 'multiLanguage',
    initialState,
    reducers: {
        openModal: (state) => {
            state.isModalOpen = true;
        },
        openModalInSidebar: (state) => {
            state.isModalOpenInSidebar = true;
        },
        closeModal: (state) => {
            state.isModalOpen = false;
            state.isModalOpenInSidebar = false;
        },
    },
});

export const { openModal, openModalInSidebar,  closeModal } = multiLanguageSlice.actions;

export default multiLanguageSlice.reducer;